export default __webpack_public_path__ + "static/media/programme1.990cab89.webp";